// client/src/components/pages/LexiStar/Maintenance/QuickBooking.tsx (ST-00249)
//
// "Report breakdown" / "Book maintenance" straight from somewhere else (the control room's truck
// chips): loads the organisation's codes once, then opens the Maintenance page's EventDialog on
// the truck. While the codes load, a small "loading" dialog; if they cannot load, its message.

import { useEffect, useState } from 'react';
import { listCodes, errorText } from '../../../../services/lexistarMaintenance';
import type { MaintenanceCode, TimeEvent } from '../../../../types/lexistar-maintenance';
import EventDialog, { type DialogAsset } from './EventDialog';
import type { BookingMode } from './maintenanceLogic';

export interface QuickBookingProps {
  mode: BookingMode;
  assetId: string;
  assets: DialogAsset[];
  onClose: () => void;
  onDone: (event: TimeEvent, message: string) => void;
}

export default function QuickBooking({ mode, assetId, assets, onClose, onDone }: QuickBookingProps) {
  const [codes, setCodes] = useState<MaintenanceCode[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    listCodes()
      .then((res) => {
        if (live) setCodes(res.codes);
      })
      .catch((err) => {
        if (live) setError(errorText(err, 'Could not load the maintenance codes.'));
      });
    return () => {
      live = false;
    };
  }, []);

  if (codes) {
    return <EventDialog mode={mode} assets={assets} codes={codes} assetId={assetId} onClose={onClose} onDone={onDone} />;
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div role="dialog" aria-modal="true" aria-label="Loading" className="bg-surface rounded-2xl shadow-2xl max-w-sm w-full mx-4 p-6 space-y-4">
        <p className={`text-sm ${error ? 'text-red-700' : 'text-slate-700'}`} role={error ? 'alert' : 'status'}>
          {error || 'Loading the maintenance codes…'}
        </p>
        <div className="flex justify-end">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-slate-600 bg-surface border border-slate-200 rounded-lg hover:bg-slate-50">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
